"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockScopedDataDefinitionUidForBatchedIngest = exports.mockScopedDataDefinitionForRedisItem = exports.mockDataBucketDefinition = exports.mockTimeRotatingListDefinition = void 0;
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const constants_iso_1 = require("@wranggle/constants-iso");
const mock_service_conn_1 = require("./mock-service-conn");
const DefaultBaseScopedDataDefinitionArgs = {
    primarySegment: 'test_data_def',
    embeddedVarNames: ['categoryCode'],
    scopedDataDefinitionUid: 'fakeUidForScopedDataDefinitionTest',
    memberTracking: constants_iso_1.ScopedDataMemberTrackingStrategy.UnsortedSet,
};
function mockTimeRotatingListDefinition(args = {}) {
    let { msPerPeriod, memberTracking } = args;
    return Object.assign(Object.assign({}, _baseScopedDataDefinition(args)), { varSegment: `${_varSegment(args)}/period/:period`, dataType: constants_iso_1.DataRefDataType.RedisList, msPerPeriod: msPerPeriod || constants_iso_1.HourMs, memberTracking: constants_iso_1.ScopedDataMemberTrackingStrategy.TimeSortedSet });
}
exports.mockTimeRotatingListDefinition = mockTimeRotatingListDefinition;
function mockDataBucketDefinition(args) {
    let { enableWsSync, memberTracking } = args;
    return Object.assign(Object.assign({}, _baseScopedDataDefinition(args)), { dataType: constants_iso_1.DataRefDataType.RedisHash, enableWsSync, memberTracking: memberTracking || constants_iso_1.ScopedDataMemberTrackingStrategy.UnsortedSet });
}
exports.mockDataBucketDefinition = mockDataBucketDefinition;
function mockScopedDataDefinitionForRedisItem(args) {
    const { durationMs, memberTracking } = args;
    return Object.assign(Object.assign({}, _baseScopedDataDefinition(args)), { dataType: constants_iso_1.DataRefDataType.RedisItem, durationMs, memberTracking: memberTracking || constants_iso_1.ScopedDataMemberTrackingStrategy.None });
}
exports.mockScopedDataDefinitionForRedisItem = mockScopedDataDefinitionForRedisItem;
function mockScopedDataDefinitionUidForBatchedIngest(organizationUid) {
    return mockTimeRotatingListDefinition({
        msPerPeriod: 3000,
        primarySegment: '_$w_batchedIngest',
        scopedDataDefinitionUid: `org$${organizationUid}`, // not actually persisted, gets special treatment for now... :/
    });
}
exports.mockScopedDataDefinitionUidForBatchedIngest = mockScopedDataDefinitionUidForBatchedIngest;
function _baseScopedDataDefinition(args) {
    let { scopedDataDefinitionUid, serviceConnUid, memberTracking, primarySegment, redisShardNdx } = args;
    return lodash_merge_1.default({
        serviceConnUid: mock_service_conn_1.mockServiceConn().serviceConnUid,
    }, DefaultBaseScopedDataDefinitionArgs, {
        varSegment: _varSegment(args),
        scopedDataDefinitionUid,
        primarySegment,
        memberTracking,
        serviceConnUid,
        redisShardNdx,
    });
}
function _varSegment(args) {
    const { embeddedVarNames, varSegment } = args;
    if (embeddedVarNames && varSegment) {
        throw new Error('Expecting either embeddedVarNames or varSegment, not both');
    }
    if (varSegment) {
        return varSegment;
    }
    if (!embeddedVarNames) {
        return '';
    }
    return embeddedVarNames.map(n => `/${n}/:${n}`).join('');
}
//# sourceMappingURL=mock-scoped-data-definition.js.map